import { render, staticRenderFns } from "./cTable.vue?vue&type=template&id=06012fb2&scoped=true"
import script from "./cTable.vue?vue&type=script&lang=js"
export * from "./cTable.vue?vue&type=script&lang=js"
import style0 from "./cTable.vue?vue&type=style&index=0&id=06012fb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06012fb2",
  null
  
)

export default component.exports